import $ from 'jquery';

let timerPull = [];

const Timer = function(options) {
	const timer_keys = ['day', 'hour', 'min', 'sec'];

	$.extend(this, options);

	this.opts.time_keys = timer_keys.filter(function(key){
		return this[key] !== false
	}, this.opts.show || {});

	const date = new Date(this.$el.data('start-at'));

	this.opts.start_at = isNaN(+date) ? new Date() : date;

	this.updateTime().tick();

	return this;
};

Timer.prototype.tick = function() {
	const
		{ time_keys, interval } = this.opts,
		html = time_keys.map(this.getItemHTML, this).join('');

	this.$el.html(html);
	this.$el.trigger('tick');

	if (!this.isComplete()) {
		this.updateTime();

		this.opts.timeout_id = setTimeout(this.tick.bind(this), interval);

		return this;
	}

	this.$el.trigger('complete');

	return this;
};

Timer.prototype.getItemHTML = function(label) {
	let { end_time, time_keys, separator } = this.opts,
		int_val = end_time[label],
		value = this._addZero(int_val),
		desc = label + (int_val !== 1 ? 's' : ''),
		is_last_label = time_keys.indexOf(label) === time_keys.length - 1
	;

	if (!is_last_label) {
		value += separator;
	}

	return this.opts.template({
		value,
		label: desc,
		short_value: int_val,
		short_label: desc[0]
	});
};

Timer.prototype._addZero = function(val) {
	return (val < 10) ? '0' + val : val;
};

Timer.prototype.getTime = function(time_left) {
	let time, millis, days, hours, minutes, seconds;

	time = time_left < 0 ? 0 : time_left;

	millis = parseInt(time / 1000, 10);
	days = Math.floor(millis / 3600 / 24);
	hours = Math.floor(millis / 3600 % 24);
	minutes = Math.floor(millis / 60 % 60);
	seconds = Math.floor(millis % 60);

	return {
		day: days,
		hour: hours,
		min: minutes,
		sec: seconds
	}
};

Timer.prototype.updateTime = function() {
	const
		now = new Date(),
		start = new Date(this.opts.start_at);

	this.opts.end_time = this.getTime(start - now);

	return this;
};

Timer.prototype.isComplete = function() {
	function accumulate(prev, next_key) {
		return prev + time[next_key];
	}

	const
		time = this.opts.end_time,
		keys = Object.keys(time);

	return !keys.reduce(accumulate, 0);
};

Timer.prototype.destroy = function() {
	clearTimeout(this.opts.timeout_id);

	return this;
};

$.fn.calculateTime = function(time) {
	return Timer.prototype.getTime(time);
};

$.fn.countdown = function(options) {
	this.$el = $(this);

	return this.each(function() {
		const opts = $.extend({}, $.fn.countdown.defaults, options);

		const timer = new Timer({
			$el: $(this),
			opts
		});

		timerPull.push(timer);
	});
};

$.fn.countdownDestroy = function() {
	return this.each(function() {
		const $current = $(this);

		timerPull = timerPull.filter(function(timer) {
			const is_equal = $current.is(timer.$el);

			is_equal && timer.destroy();

			return is_equal;
		});
	});
};

// Simple JavaScript Templating
// John Resig - http://ejohn.org/ - MIT Licensed
$.fn.countdown.template = (function() {
	const cache = {};

	return function tmpl(str, data) {
		// Figure out if we're getting a template, or if we need to
		// load the template - and be sure to cache the result.
		const fn = !/\W/.test(str) ?
			cache[str] = cache[str] ||
				tmpl(document.getElementById(str).innerHTML) :

			// Generate a reusable function that will serve as a template
			// generator (and which will be cached).
			new Function("obj",
				"var p=[],print=function(){p.push.apply(p,arguments);};" +

				// Introduce the data as local variables using with(){}
				"with(obj){p.push('" +

				// Convert the template into pure JavaScript
				str
					.replace(/[\r\t\n]/g, " ")
					.split("<%").join("\t")
					.replace(/((^|%>)[^\t]*)'/g, "$1\r")
					.replace(/\t=(.*?)%>/g, "',$1,'")
					.split("\t").join("');")
					.split("%>").join("p.push('")
					.split("\r").join("\\'")
				+ "');}return p.join('');");

		// Provide some basic currying to the user
		return data ? fn(data) : fn;
	};
})();

$.fn.countdown.defaults = {
	separator: '',
	interval: 1000,
	template: $.fn.countdown.template(
		'<div class="timer-item">' +
			'<div class="item-value"><%= value %></div>' +
			'<div class="item-label"><%= label %></div>' +
		'</div>'
	)
};